module.exports = __webpack_public_path__ + "img/01logo-rin2022.5791302f.png";